import { FieldErrors, useFormContext } from 'react-hook-form'
import { BefehlFormAuftrag, BefehlFormField } from '../Generic'
import { useTranslation } from 'react-i18next'
import { Input } from '../../form'
import { useMemo } from 'react'

export interface Auftrag28_10FormProps {
  befehlKennung: string
  fieldPrefix: string
  readOnly: boolean
  'data-testid': string
  errors?: FieldErrors
  activateEmptyFieldWarnings: boolean
}

export default function Auftrag28_10Form({
  readOnly,
  'data-testid': testId,
  fieldPrefix,
  activateEmptyFieldWarnings = false
}: Readonly<Auftrag28_10FormProps>) {
  const formContext = useFormContext()
  const { control, formState, watch, resetField } = formContext
  const { t } = useTranslation('ui-befehle')

  const formErrors = useMemo(() => {
    return formState.errors
  }, [formState.errors])

  const auftrag_28_10_inactive = !watch('auftrag_28_10.enabled')

  return (
    <BefehlFormAuftrag
      auftragKennung="28.10"
      fieldName="auftrag_28_10.enabled"
      control={control}
      readOnly={readOnly}
      testId={testId}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      onChange={(checked) => {
        if (!checked) {
          resetField('auftrag_28_10')
        }
      }}
    >
      <div className="@container">
        <div
          className="flex flex-col @[350px]:flex-row items-baseline gap-1"
          data-testid={`${testId}-outer-div`}
        >
          <span data-testid={`${testId}-text`}>
            {t('auftraege.28_10.label')}
          </span>
          <div className="flex flex-col">
            <BefehlFormField
              name={'auftrag_28_10.etcsLevel'}
              control={control}
              label={t('auftraege.28_10.etcs_level_label')}
              readOnly={readOnly}
              activateEmptyWarning={activateEmptyFieldWarnings}
              data-testid={`${fieldPrefix}-feld-28-11`}
              render={({ field }) => (
                <Input
                  {...field}
                  name={'auftrag_28_10.etcsLevel'}
                  label={t('auftraege.28_10.etcs_level_label')}
                  errors={formErrors}
                  disabled={auftrag_28_10_inactive}
                  className="w-full"
                  data-testid={`${testId}-feld-28-11-inner`}
                />
              )}
            ></BefehlFormField>

            <div>
              <span
                className={
                  auftrag_28_10_inactive ? 'text-gray-500 opacity-60' : ''
                }
                data-testid={`${fieldPrefix}-feld-28-11-label`}
              >
                {t('auftraege.28_10.input_label_etcs_level')}
              </span>
            </div>
          </div>
          <span data-testid={`${fieldPrefix}-text-waehlen`}>
            {t('auftraege.28_10.after_input')}
          </span>
        </div>
      </div>
    </BefehlFormAuftrag>
  )
}
